import { render, staticRenderFns } from "./risk-budget-request.vue?vue&type=template&id=48405b03"
import script from "./risk-budget-request.ts?vue&type=script&lang=ts&external"
export * from "./risk-budget-request.ts?vue&type=script&lang=ts&external"
import style0 from "./risk-budget-request.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48405b03')) {
      api.createRecord('48405b03', component.options)
    } else {
      api.reload('48405b03', component.options)
    }
    module.hot.accept("./risk-budget-request.vue?vue&type=template&id=48405b03", function () {
      api.rerender('48405b03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/budget-request/risk-budget-request/risk-budget-request.vue"
export default component.exports